import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  dropdowns: {},
  countries: [],
  states: [],
  cities: [],
  paymentMethods: [],
  fetchingDropdown: false,
  fetchingCountries: false,
  fetchingStates: false,
  fetchingCities: false,
  fetchingPaymentMethods: false,
  companyDetails: null,
};

const companyEditSlice = createSlice({
  name: "companyEdit",
  initialState,
  reducers: {
    fetchCompanyDetails(state, action) {
      state.loading = true;
    },
    fetchCompanyDetailsSuccess(state, action) {
      state.companyDetails = action.payload.data.document;
      state.loading = false;
    },
    fetchCompanyDetailsFailure(state, action) {
      state.loading = false;
    },
    updateCompany(state, action) {
      state.loading = true;
      state.error = null;
    },
    updateCompanySuccess(state, action) {
      state.error = null;
      state.loading = false;
    },
    updateCompanyFailure(state, action) {
      state.loading = false;
      state.error = action.payload.message;
    },
    initializeError(state, action) {
      state.error = null;
    },
    fetchDropdown(state, action) {
      state.fetchingDropdown = true;
    },
    fetchDropdownSuccess(state, action) {
      state.fetchingDropdown = false;
      state.dropdowns = action.payload.data.document;
    },
    fetchDropdownFailure(state, action) {
      state.fetchingDropdown = false;
    },
    fetchCountries(state, action) {
      state.fetchingCountries = true;
    },
    fetchCountriesSuccess(state, action) {
      state.fetchingCountries = false;
      state.countries = action.payload.data.document;
    },
    fetchCountriesFailure(state, action) {
      state.fetchingCountries = false;
    },
    fetchStates(state, action) {
      state.fetchingStates = true;
    },
    fetchStatesSuccess(state, action) {
      state.fetchingStates = false;
      state.states = action.payload.data.document;
    },
    fetchStatesFailure(state, action) {
      state.fetchingStates = false;
    },
    fetchCities(state, action) {
      state.fetchingCities = true;
    },
    fetchCitiesSuccess(state, action) {
      state.fetchingCities = false;
      state.cities = action.payload.data.document;
    },
    fetchCitiesFailure(state, action) {
      state.fetchingCities = false;
    },
    initializeState(state, action) {
      state.loading = false;
      state.error = null;
      state.dropdowns = {};
      state.countries = [];
      state.states = [];
      state.cities = [];
      state.paymentMethods = [];
      state.fetchingDropdown = false;
      state.fetchingCountries = false;
      state.fetchingStates = false;
      state.fetchingCities = false;
      state.fetchingPaymentMethods = false;
      state.companyDetails = null;
    },
  },
});

export const { actions, reducer, name: sliceKey } = companyEditSlice;
